import { render, staticRenderFns } from "./PosDetailDialog.vue?vue&type=template&id=5364f2a0&"
import script from "./PosDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PosDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./PosDetailDialog.vue?vue&type=style&index=0&id=5364f2a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports